const createMuiTouchRipple = () => ({
    styleOverrides: {
        root: {
            padding: '6px',
        },
    },
});

export default createMuiTouchRipple;
